import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { type PartnerEventDetail } from '@/api/routes/partners/partners.events.api';
import { formatEventDateTime, getPartnerEventDisplayStatus } from '@/domain/events/utils';
import { useTranslate } from '@/state/i18n';

interface Props {
  event: PartnerEventDetail;
}

/** The status message above the detail: in review (P11), rejected with the note (P13), canceled. */
const EventStatusAlert = ({ event }: Props) => {
  const t = useTranslate('domain.events.components.EventStatusAlert');
  const status = getPartnerEventDisplayStatus(event);

  if (status === 'canceled' && event.canceledAt) {
    return (
      <Alert severity="warning">
        <AlertTitle>
          {t('canceledTitle', { date: formatEventDateTime(event.canceledAt) })}
        </AlertTitle>
        {t('canceled')}
      </Alert>
    );
  }
  if (status === 'in_review') {
    return (
      <Alert severity="info">
        <AlertTitle>
          {event.submittedAt
            ? t('inReviewTitle', { date: formatEventDateTime(event.submittedAt) })
            : t('inReviewTitleNoDate')}
        </AlertTitle>
        {t('inReview')}
      </Alert>
    );
  }
  if (status === 'rejected') {
    return (
      <Alert severity="error">
        <AlertTitle>{t('rejectedTitle')}</AlertTitle>
        {event.lastReviewNote ?? t('rejectedNoNote')}
      </Alert>
    );
  }
  if (status === 'approved') {
    return <Alert severity="success">{t('approved')}</Alert>;
  }
  return null;
};

export default EventStatusAlert;
